import createInstance from '../libs/axios'
// baseURL configurable por env (REACT_APP_API_USERS); fallback a producción.
const instance = createInstance(process.env.REACT_APP_API_USERS || 'https://5ncha74147.execute-api.sa-east-1.amazonaws.com/production')

export default instance